<template>
  <div class="wrapper" style="padding:15px;">
    <el-form ref="formData" :model="formData" label-width="150px">
      <el-row :gutter="20">
        <!--<el-col :span="8">
          <el-form-item prop="code" label="编码">
             <el-input v-model="formData.code"></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="branchCode" label="机构编码">
             <el-input v-model="formData.branchCode" disabled></el-input>
           </el-form-item>
        </el-col>
       </el-row>
       <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="shipperName" label="发布方姓名">
             <el-input v-model="formData.shipperName" @focus="Shipperlist()"></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shipperIdNo" label="发布方身份证件号码">
             <el-input v-model="formData.shipperIdNo"></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shipperMobile" label="发布方身手机号码">
             <el-input v-model="formData.shipperMobile"></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="countryCode" label="国籍">
            <el-input v-model="formData.industryCodeName"></el-input>
           </el-form-item>
        </el-col>-->
        <el-col :span="8">
          <el-form-item prop="companyName" label="企业名称">
            <el-input
              v-model="formData.companyName"
              clearable
              placeholder="请选择企业"
              @focus="Shipperlist()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyPhone" label="企业手机电话号码">
            <el-input
              v-model="formData.companyPhone"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyTaxId" label="企业纳税人识别号">
            <el-input
              v-model="formData.companyTaxId"
              clearable
              :disabled="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyAddressCode" label="公司地址">
            <el-cascader
              ref="companyAddressCode"
              v-model="companyAddressCode"
              :options="options"
              disabled
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="detailAddress" label="详细地址">
            <el-input v-model="formData.detailAddress" clearable disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="legalPerson" label="法定代表人">
            <el-input v-model="formData.legalPerson" clearable disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="registerCapital" label="注册资本">
            <el-input v-model="formData.registerCapital" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="establishDate" label="成立日期">
            <el-date-picker
              v-model="formData.establishDate"
              clearable
              type="date"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="registerTime" label="平台注册时间">
            <el-date-picker
              v-model="formData.registerTime"
              clearable
              type="date"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd"
              disabled=""
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="myTaxOrgan" label="所属主管税务机关">
            <el-input v-model="formData.myTaxOrgan" clearable disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业类型" prop="companyType">
            <el-select
              v-model="formData.companyType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in companyTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="businessScope" label="经营范围">
            <el-input v-model="formData.businessScope" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上传证件" required>
            <div class="avatarList">
              <div v-for="(item, index) in imageList" :key="index" class="flex">
                <img class="avatar" :src="item" />
                <span class="el-upload-list__item-actions" @click.stop>
                  <span
                    class="el-upload-list__item-icon"
                    @click.stop="handlePictureCardPreview(index)"
                  >
                    <i class="el-icon-zoom-in" />
                  </span>
                </span>
              </div>
            </div>
            <el-dialog :visible.sync="showImageFlag">
              <img width="100%" :src="showImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      code: "",
      imageList: [],
      formData: {},
      companyTypeOptions: [
        { label: "一般人", value: 0 },
        { label: "小规模", value: 1 }
      ],
      registerAreaCode: "",
      companyAddressCode: [],
      options: this.$store.state.components.areaOptions,
      fileList: [],
      stateList: [],
      branchCode: this.$store.state.user.party.branchCode,
      showImageFlag: false,
      showImageUrl: ""
    };
  },
  created() {
    let query = this.$route.query;
    this.formData.branchCode = this.branchCode;
    // this.Seladdress()
    if (query) {
      this.getInfo(query);
    }
  },
  methods: {
    getInfo(query) {
      request({
        url: `/ntocc-basic-api/taxShipper/publish_info`,
        method: "get",
        params: query
      }).then(response => {
        this.formData = response.data;
        this.imageList = [response.data.businessLicenseImg];
        this.companyAddressCode = [
          response.data.provinceCode,
          response.data.cityCode,
          response.data.countyCode
        ];
      });
      // taxCargo?app_id=1&sign_key=641f9dabe355dda453d9f49863591ea4&time=3&fbfuuid=02a2ca80f80543508fd1b9653d42b580
    },
    // 放大
    handlePictureCardPreview(index) {
      this.showImageUrl = this.fileList[index];
      this.showImageFlag = true;
    }
  }
};
</script>
<style scoped lang="scss">
.avatarList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .flex {
    position: relative;
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
    border: 1px solid #c0ccda;
  }
}
.avatar {
  width: 100%;
}
.avatar-uploader {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 150px;
  border-radius: 10px;
  overflow: hidden;
  .avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
    border-radius: 10px;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px dashed #c0ccda;
    &:hover {
      border-color: #409eff;
    }
    p {
      font-size: 14px;
      margin: 0;
    }
  }
}
.el-upload-list__item-actions {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
  .el-upload-list__item-icon {
    cursor: pointer;
    margin: 0 10px;
  }
}
</style>
